// src/Hooks/useNetworkLoading.js
import { useEffect } from "react";
import useLoading, { SLOW_THRESHOLD_MS } from "./useLoading";

/**
 * Monitora chamadas de rede e dispara o loading global SOMENTE
 * quando uma requisição passa de SLOW_THRESHOLD_MS.
 * Requisições rápidas nunca acionam overlay (evita "flash").
 */
export default function useNetworkLoading() {
  const { start, stop } = useLoading();

  useEffect(() => {
    // ---------- fetch ----------
    const originalFetch = window.fetch;

    window.fetch = async function patchedFetch(...args) {
      let triggered = false;
      const slowTimer = setTimeout(() => {
        triggered = true;
        start();
      }, SLOW_THRESHOLD_MS);

      try {
        return await originalFetch.apply(this, args);
      } finally {
        clearTimeout(slowTimer);
        if (triggered) stop();
      }
    };

    // ---------- XMLHttpRequest (para libs/antigos) ----------
    const OriginalXHR = window.XMLHttpRequest;

    function WrappedXHR() {
      const xhr = new OriginalXHR();
      let triggered = false;
      let slowTimer = null;

      const send = xhr.send.bind(xhr);
      xhr.send = function patchedSend(...args) {
        slowTimer = setTimeout(() => {
          triggered = true;
          start();
        }, SLOW_THRESHOLD_MS);

        xhr.addEventListener("loadend", () => {
          if (slowTimer) clearTimeout(slowTimer);
          if (triggered) stop();
        });

        return send(...args);
      };

      return xhr;
    }
    WrappedXHR.prototype = OriginalXHR.prototype;
    window.XMLHttpRequest = WrappedXHR;

    return () => {
      window.fetch = originalFetch;
      window.XMLHttpRequest = OriginalXHR;
    };
  }, [start, stop]);
}